import { createContext } from 'react';

//Types
import { ThemeContextType } from "@/@types/context/ThemeContext";

const ThemeContext = createContext<ThemeContextType | null>(null);

ThemeContext.displayName = 'ThemeContext';
export default ThemeContext
